import { ChevronLeft, ChevronRight } from "lucide-react";

interface CalendarNavigationProps {
  currentMonth: string;
  currentYear: number;
  onPrevMonth: () => void;
  onToday: () => void;
  onNextMonth: () => void;
}

export function CalendarNavigation({
  currentMonth,
  currentYear,
  onPrevMonth,
  onToday,
  onNextMonth,
}: CalendarNavigationProps) {
  return (
    <div className="flex items-center justify-between">
      <p className="text-[18px] font-bold text-white">
        {currentMonth} {currentYear}
      </p>

      <div className="flex items-center justify-center gap-[23px]">
        <button
          onClick={onPrevMonth}
          className="flex size-[40px] items-center justify-center rounded-[20px] transition-colors hover:bg-white/10"
          type="button"
          aria-label="Mês anterior"
        >
          <ChevronLeft className="size-5 text-white" />
        </button>

        <button
          onClick={onToday}
          className="text-[16px] font-bold text-white transition-opacity hover:opacity-70"
          type="button"
        >
          Hoje
        </button>

        <button
          onClick={onNextMonth}
          className="flex size-[40px] items-center justify-center rounded-[20px] transition-colors hover:bg-white/10"
          type="button"
          aria-label="Próximo mês"
        >
          <ChevronRight className="size-5 text-white" />
        </button>
      </div>
    </div>
  );
}
